/**
 * Footer Component for 2D Imaging, Inc. Website
 */

class Footer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `
    <!-- Footer -->
    <footer>
        <div class="container">
            <div class="footer-content">
                <div class="footer-col">
                    <h4>2D IMAGING, INC.</h4>
                    <p>Your trusted ultrasound equipment and service partner in Southern California and nationwide.</p>
                    <div class="social-links">
                        <a href="#"><i class="fab fa-linkedin-in"></i></a>
                    </div>
                </div>
                <div class="footer-col">
                    <h4>Quick Links</h4>
                    <ul class="footer-links">
                        <li><a href="/">Home</a></li>
                        <li><a href="/pages/services">Services</a></li>
                        <li><a href="/collections/all">Products</a></li>
                        <li><a href="/pages/about">About</a></li>
                        <li><a href="/pages/careers">Careers</a></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>
                </div>
                <div class="footer-col">
                    <h4>Services</h4>
                    <ul class="footer-links">
                        <li><a href="/pages/services#onsite">On-Site Maintenance</a></li>
                        <li><a href="/pages/services#mailin">Mail-In Repairs</a></li>
                    </ul>
                </div>
                <div class="footer-col">
                    <h4>Contact Us</h4>
                    <ul class="footer-links">
                        <li><a href="tel:7145245888">(714) 524-5888</a></li>
                        <li><a href="mailto:support@2dimaging.com">support@2dimaging.com</a></li>
                    </ul>
                </div>
            </div>
            <div class="footer-bottom">
                <p>&copy; 2024 2D IMAGING, INC. All Rights Reserved. &nbsp;·&nbsp; <a href="/policies/refund-policy">Refund Policy</a></p>
            </div>
        </div>
    </footer>
    `;
  }
}

customElements.define("site-footer", Footer); 